import React, { useState, useEffect } from "react";
import { useQuery, useMutation } from "react-query";
import { toast } from "react-toastify";
import api from "../../../utils/api";

export default function LabProfile() {
  const [form, setForm] = useState({
    name: "", email: "", phone: "", address: "", city: "",
    license_number: "", description: "", homeCollection: false,
  });

  const { data, isLoading } = useQuery("lab-profile", () =>
    api.get("/lab/profile")
  );

  useEffect(() => {
    if (data?.profile) setForm(data.profile);
  }, [data]);

  const updateMutation = useMutation(
    () => api.put("/lab/profile", form),
    { onSuccess: () => toast.success("Profile updated") }
  );

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));

  if (isLoading) return <div className="text-slate-500">Loading…</div>;

  return (
    <div className="max-w-2xl">
      <div className="card">
        <h2 className="font-display font-semibold text-slate-800 text-lg mb-6">Lab Profile</h2>
        <div className="grid grid-cols-2 gap-4">
          {[
            { name: "name", label: "Lab Name" },
            { name: "email", label: "Email", type: "email" },
            { name: "phone", label: "Phone" },
            { name: "license_number", label: "License Number" },
            { name: "address", label: "Address" },
            { name: "city", label: "City" },
          ].map(({ name, label, type = "text" }) => (
            <div key={name} className={name === "address" ? "col-span-2" : ""}>
              <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">{label}</label>
              <input type={type} name={name} value={form[name]} onChange={handleChange} className="input-field" />
            </div>
          ))}
          <div className="col-span-2">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">Description</label>
            <textarea name="description" value={form.description} onChange={handleChange} rows={3} className="input-field resize-none" />
          </div>
          <div className="col-span-2 flex items-center gap-3">
            <input
              type="checkbox"
              id="homeCollection"
              name="homeCollection"
              checked={form.homeCollection}
              onChange={handleChange}
              className="w-4 h-4 accent-primary-600"
            />
            <label htmlFor="homeCollection" className="text-sm text-slate-700 cursor-pointer">
              Offer Home Collection Service
            </label>
          </div>
        </div>
        <button onClick={() => updateMutation.mutate()} disabled={updateMutation.isLoading} className="btn-primary mt-5">
          {updateMutation.isLoading ? "Saving…" : "Save Changes"}
        </button>
      </div>
    </div>
  );
}
